// extracted by mini-css-extract-plugin
export default {"pagination":"ExportQueue_pagination__HUNmg","descriptionText":"ExportQueue_descriptionText__qkAuh"};